/* =====================================================================
   NDP Magia - comportamenti degli articoli (nessuna libreria, ~5 KB)
   - aggiunge .mg-pronto all'articolo: senza JS tutto resta visibile
   - comparse, disegni a filo, respiro: si attivano in vista e si fermano fuori
   - indice che segue la lettura, filo d'oro di avanzamento
   - interruttori [data-mg-scelta] + pannelli [data-mg-when]
   - liste da spuntare [data-mg-lista] salvate sul telefono, condivisibili
   API per gli script dei singoli articoli: window.NDPMagia
   ===================================================================== */
(function () {
  'use strict';
  var radice = document.querySelector('.ndp-mg');
  if (!radice) return;

  var riduci = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var haIO = 'IntersectionObserver' in window;

  function memoria(chiave, valore) {
    try {
      if (valore === undefined) return JSON.parse(localStorage.getItem('ndp-mg:' + chiave));
      localStorage.setItem('ndp-mg:' + chiave, JSON.stringify(valore));
    } catch (e) { return null; }
  }

  function inVista(el, entra, esce, opzioni) {
    if (!haIO) { entra(el); return; }
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) entra(v.target); else if (esce) esce(v.target); });
    }, opzioni || { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    io.observe(el);
    return io;
  }

  function annuncia(testo) {
    var vivo = radice.querySelector('.ndp-mg-vivo');
    if (!vivo) {
      vivo = document.createElement('div');
      vivo.className = 'ndp-mg-vivo';
      vivo.setAttribute('aria-live', 'polite');
      vivo.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';
      radice.appendChild(vivo);
    }
    vivo.textContent = testo;
  }

  function festa(contenitore) {
    if (riduci || !contenitore) return;
    var f = document.createElement('div');
    f.className = 'ndp-mg-festa';
    /* i coriandoli partono dal centro della parte VISIBILE del contenitore, anche se è più lungo dello schermo */
    var r = contenitore.getBoundingClientRect();
    var visSu = Math.max(0, -r.top);
    var visGiu = Math.min(r.height, window.innerHeight - r.top);
    var origine = Math.round(visSu + Math.max(0, visGiu - visSu) / 2);
    for (var i = 0; i < 18; i++) {
      var c = document.createElement('i');
      c.style.top = origine + 'px';
      var ang = (i / 18) * Math.PI * 2;
      var dist = 90 + Math.random() * 90;
      c.style.setProperty('--x', Math.round(Math.cos(ang) * dist) + 'px');
      c.style.setProperty('--y', Math.round(Math.sin(ang) * dist - 40) + 'px');
      c.style.setProperty('--r', Math.round(Math.random() * 540) + 'deg');
      c.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      if (i % 3 === 0) c.style.background = '#E9DDBE';
      f.appendChild(c);
    }
    if (getComputedStyle(contenitore).position === 'static') contenitore.style.position = 'relative';
    contenitore.appendChild(f);
    setTimeout(function () { f.remove(); }, 1800);
  }

  /* 1. Movimento: comparse, disegni, respiro (solo se non si chiede di ridurlo) */
  radice.querySelectorAll('[data-mg-draw]').forEach(function (box) {
    Array.prototype.forEach.call(box.getElementsByTagName('*'), function (el) {
      if (el.hasAttribute('pathLength')) el.classList.add('mg-filo');
    });
  });
  radice.classList.add('mg-pronto', 'mg-attivo');
  var animati = radice.querySelectorAll('[data-mg-reveal], [data-mg-draw]');
  if (riduci) {
    animati.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    animati.forEach(function (el) {
      var io = inVista(el, function (t) { t.classList.add('is-in'); if (io) io.unobserve(t); });
    });
    radice.querySelectorAll('[data-mg-vivo-in-vista]').forEach(function (el) {
      el.classList.add('mg-fermo');
      /* stessa soglia del disegno: respiro e scintille partono quando l'illustrazione si vede davvero */
      inVista(el, function (t) { t.classList.remove('mg-fermo'); }, function (t) { t.classList.add('mg-fermo'); });
    });
  }

  /* 2. Filo d'oro di lettura: CSS scroll-timeline se c'è, altrimenti JS leggero */
  var filo = radice.querySelector('.ndp-mg-filo');
  if (filo && !(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'))) {
    var inAttesa = false;
    var aggiorna = function () {
      inAttesa = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      filo.style.setProperty('--mg-p', max > 0 ? Math.min(1, window.scrollY / max).toFixed(4) : 0);
    };
    window.addEventListener('scroll', function () { if (!inAttesa) { inAttesa = true; requestAnimationFrame(aggiorna); } }, { passive: true });
    aggiorna();
  }

  /* 3. Indice: costruito dagli h2 con id, segue la lettura */
  var indice = radice.querySelector('[data-mg-indice]');
  var corpo = radice.querySelector('.ndp-mg-corpo');
  if (indice && corpo) {
    var titoli = corpo.querySelectorAll('h2[id]');
    var lista = indice.querySelector('ol');
    if (lista && titoli.length && !lista.children.length) {
      titoli.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.getAttribute('data-mg-breve') || h.textContent;
        li.appendChild(a);
        lista.appendChild(li);
      });
    }
    var link = indice.querySelectorAll('a[href^="#"]');
    var dettagli = indice.querySelector('details');
    link.forEach(function (a) { a.addEventListener('click', function () { if (dettagli && window.innerWidth < 1000) dettagli.open = false; }); });
    if (haIO && titoli.length) {
      var attivo = null;
      var segna = function (id) {
        if (id === attivo) return;
        attivo = id;
        link.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + id ? 'true' : 'false'); });
      };
      var oss = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { if (v.isIntersecting) segna(v.target.id); });
      }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
      titoli.forEach(function (h) { oss.observe(h); });
    }
  }

  /* 4. Interruttori: <div class="ndp-mg-scelta" data-mg-scelta="stagione"> <button data-mg-valore="inverno"> */
  var prefisso = (radice.id || 'articolo') + ':';
  radice.querySelectorAll('[data-mg-scelta]').forEach(function (gruppo) {
    var nome = gruppo.getAttribute('data-mg-scelta');
    var bottoni = gruppo.querySelectorAll('button[data-mg-valore]');
    var scegli = function (valore, salva) {
      bottoni.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mg-valore') === valore ? 'true' : 'false'); });
      radice.querySelectorAll('[data-mg-when]').forEach(function (p) {
        var regola = p.getAttribute('data-mg-when').split(':');
        if (regola[0] !== nome) return;
        p.hidden = regola[1].split('|').indexOf(valore) === -1;
      });
      radice.setAttribute('data-mg-' + nome, valore);
      if (salva) memoria('scelta:' + prefisso + nome, valore);
      radice.dispatchEvent(new CustomEvent('mg:scelta', { detail: { nome: nome, valore: valore } }));
    };
    bottoni.forEach(function (b) { b.addEventListener('click', function () { scegli(b.getAttribute('data-mg-valore'), true); }); });
    var salvata = memoria('scelta:' + prefisso + nome);
    var iniziale = gruppo.querySelector('[aria-pressed="true"]');
    scegli(salvata && gruppo.querySelector('[data-mg-valore="' + salvata + '"]') ? salvata : (iniziale ? iniziale.getAttribute('data-mg-valore') : bottoni[0].getAttribute('data-mg-valore')), false);
  });

  /* 5. Liste da spuntare: <section class="ndp-mg-lista" data-mg-lista="corredino"> */
  radice.querySelectorAll('[data-mg-lista]').forEach(function (box) {
    var chiave = 'lista:' + box.getAttribute('data-mg-lista');
    var stato = memoria(chiave) || {};
    var barra = box.querySelector('.ndp-mg-lista__barra');
    var conto = box.querySelector('[data-mg-conto]');
    var completata = false;
    var visibili = function () {
      return Array.prototype.filter.call(box.querySelectorAll('input[type="checkbox"]'), function (c) { return !c.closest('[hidden]'); });
    };
    var ricalcola = function (daUtente) {
      var v = visibili();
      var fatte = v.filter(function (c) { return c.checked; }).length;
      var quota = v.length ? fatte / v.length : 0;
      if (barra) barra.style.setProperty('--mg-fatto', quota.toFixed(3));
      if (conto) conto.textContent = fatte + ' di ' + v.length;
      if (daUtente && quota === 1 && !completata) {
        completata = true;
        festa(box);
        annuncia('Lista completa. Tutto pronto!');
        box.dispatchEvent(new CustomEvent('mg:completa', { bubbles: true }));
      }
      if (quota < 1) completata = false;
    };
    box.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
      if (stato[c.id]) c.checked = true;
      c.addEventListener('change', function () {
        stato[c.id] = c.checked;
        memoria(chiave, stato);
        ricalcola(true);
      });
    });
    radice.addEventListener('mg:scelta', function () { ricalcola(false); });
    ricalcola(false);

    var azzera = box.querySelector('[data-mg-azzera]');
    if (azzera) azzera.addEventListener('click', function () {
      if (!window.confirm('Vuoi ricominciare la lista da capo?')) return;
      stato = {};
      memoria(chiave, stato);
      box.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      ricalcola(false);
    });

    var condividi = box.querySelector('[data-mg-condividi]');
    if (condividi) condividi.addEventListener('click', function () {
      var righe = visibili().map(function (c) {
        var etichetta = box.querySelector('label[for="' + c.id + '"]');
        var nome = etichetta ? (etichetta.getAttribute('data-mg-testo') || etichetta.textContent.trim().split('\n')[0]) : c.id;
        var qta = c.closest('.ndp-mg-voce').querySelector('.ndp-mg-voce__qta');
        var quanto = qta ? (qta.getAttribute('data-mg-testo') || qta.innerText || qta.textContent).trim() : '';
        return (c.checked ? '✓ ' : '○ ') + nome + (quanto ? ' (' + quanto + ')' : '');
      });
      var titolo = condividi.getAttribute('data-mg-titolo') || document.title;
      var testo = titolo + '\n\n' + righe.join('\n') + '\n\n' + location.href.split('#')[0];
      if (navigator.share) {
        navigator.share({ title: titolo, text: testo }).catch(function () {});
      } else {
        window.open('https://wa.me/?text=' + encodeURIComponent(testo), '_blank', 'noopener');
      }
    });
  });

  /* 6. Schede capi dal vivo (in produzione): <div data-mg-capi="natale" data-mg-quanti="4">
        legge l'ordine della Regia dalla collezione con la Section Rendering API, solo quando arriva in vista */
  radice.querySelectorAll('[data-mg-capi]').forEach(function (box) {
    if (box.getAttribute('data-mg-statico') === 'si') return;
    var handle = box.getAttribute('data-mg-capi');
    var sezione = box.getAttribute('data-mg-sezione') || 'ndp-mg-capi';
    inVista(box, function () {
      if (box.getAttribute('data-mg-caricato')) return;
      box.setAttribute('data-mg-caricato', '1');
      var radiceLingua = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(radiceLingua + 'collections/' + encodeURIComponent(handle) + '?section_id=' + sezione + '&filter.v.availability=1')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var riga = tmp.querySelector('.ndp-mg-shop__riga');
          var qui = box.querySelector('.ndp-mg-shop__riga');
          if (!riga || !qui || !riga.children.length) return;
          var quanti = parseInt(box.getAttribute('data-mg-quanti'), 10) || 4;
          while (riga.children.length > quanti) riga.lastElementChild.remove();
          qui.replaceWith(riga);
        })
        .catch(function () {});
    }, null, { rootMargin: '400px 0px' });
  });

  window.NDPMagia = { riduci: riduci, inVista: inVista, memoria: memoria, festa: festa, annuncia: annuncia, radice: radice };
})();
